// ProductosPdf.js
import React from 'react';
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import { Link } from '@react-pdf/renderer';

// Imágenes base
import productoPrueba from '../images/img_default.png';
import whatsapt from '../images/waza.png';
import ubicacion from '../images/uvic.png';
import mundo from '../images/mundo.png';
import {getCodeColor} from '../components';
import { useParams } from 'react-router-dom';

const API_url = process.env.REACT_APP_API_URL;

// Función para dividir en páginas de 6 productos
const chunkArray = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const ProductosPdf = ({
  products = [],
  date,
  wholesale = false,
  themeColor,
  logo_catalogo,
  nameComany,
  nit,
  branchName = '',
  phone = '',
  locationUrl = '',
  convertPrice=(()=>{}),
}) => {
  const themeConverted = getCodeColor(themeColor);

  const styles = StyleSheet.create({
    page: {
      padding: 0,
      fontFamily: 'Helvetica',
      fontSize: 9,
      backgroundColor: '#c0bebf',
    },
    header: {
      backgroundColor: themeConverted,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: `1px solid ${themeConverted}`,
      width: '100%',
      paddingHorizontal: 10,
      paddingVertical: 5,
      marginBottom: 6,
    },
    logo: { width: 160, height: 50 },
    sectionLogo: { display: 'flex', flexDirection: 'column' },
    textLogo: {
      color: '#fff',
      fontSize: '10px',
      paddingLeft: '10px',
      position: 'relative',
      bottom: '5px',
    },
    catalogoText: {
      fontSize: 18,
      fontWeight: '800',
      alignSelf: 'center',
      color: themeConverted,
      backgroundColor: '#fff',
      padding: '10px',
      borderRadius: '15px',
      letterSpacing: '0.5px',
      position: 'relative',
      right: '30px',
    },
    dateText: {
      color: '#fff',
      fontWeight: 'bold',
      fontSize: 14,
      paddingRight: '10px',
    },
    productosGrid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginTop: '5px',
    },
    productoCard: {
      display: 'flex',
      flexDirection: 'column',
      border: '1px solid #ccc',
      margin: 5,
      padding: 5,
      width: '48%',
      height: '220px',
      borderRadius: 4,
      backgroundColor: '#fff',
      shadowColor: '#000',
      shadowOffset: { width: 1, height: 1 },
      shadowOpacity: 0.2,
      shadowRadius: 2,
      elevation: 3,
    },
    cardArriba: {
      paddingTop: '5px',
      marginBottom: '3px',
      paddingBottom: '5px',
      borderBottom: `2px solid ${themeConverted}`,
    },
    cardAbajo: { display: 'flex', flexDirection: 'row' },
    productoCardLeft: { padding: 5, width: '60%', color: '#fff' },
    productoCardRight: {
      padding: 8,
      width: '40%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    productoImagen: { width: '100%', height: 160, objectFit: 'fill', marginBottom: 5 },
    productoTitulo: {
      fontSize: 10,
      fontWeight: 'bold',
      marginBottom: 2,
      textAlign: 'center',
      letterSpacing: '0.4px',
    },
    detalleCodigo: { position: 'relative', bottom: '3px', fontSize: 8 },
    detalleContenido: {
      display: 'flex',
      flexDirection: 'column',
      lineHeight: '0.7',
      backgroundColor: themeConverted,
      color: '#fff',
      padding: '5px',
      borderRadius: '10px',
      marginTop: 2,
    },
    productoInfo: { fontSize: 8, marginBottom: 1 },
    PrecioContent: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    PrecioTitle: { position: 'relative', top: '3px', fontSize: 9 },
    productoPrecio: {
      marginTop: 5,
      fontSize: 9,
      fontWeight: 'bold',
      color: '#fff',
      backgroundColor: themeConverted,
      padding: '5px',
      borderRadius: '10px',
    },
    footer: {
      backgroundColor: themeConverted,
      padding: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      fontSize: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      height: '45px',
      alignItems: 'center',
      paddingRight: '10px',
      paddingLeft: '10px',
    },
    iconFooter: { width: '20px' },
    textFooter: { color: '#fff', fontSize: '10px', marginLeft: '3px' },
    contentDatosFooter: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  });

  const productChunks = chunkArray(products, 6);
  const link_share = String(window.location.protocol) + '//' + String(window.location.hostname) + '/company/products?search=' + nit;

  return (
    <Document>
      {productChunks.map((chunk, idx) => (
        <Page key={idx} size="A4" style={styles.page}>
          {/* Encabezado */}
          <View style={styles.header}>
            <View style={styles.sectionLogo}>
              <Image src={API_url + logo_catalogo} style={styles.logo} />
              <Text style={styles.textLogo}>Nit: {nit}</Text>
              <Text style={styles.textLogo}>{nameComany}</Text>
            </View>
            <Text style={styles.catalogoText}>CATÁLOGO</Text>
            <Text style={styles.dateText}>Fecha: {date}</Text>
          </View>

          {/* Cuerpo */}
          <View style={styles.productosGrid}>
            {chunk.map((product, i) => {
              const sourceImage =
                Array.isArray(product.images) && product.images.length
                  ? API_url + product.images[0]
                  : productoPrueba;
              return (
                <View key={i} style={styles.productoCard}>
                  <View style={styles.cardArriba}>
                    <Text style={styles.productoTitulo}>{product.name}</Text>
                  </View>
                  <View style={styles.cardAbajo}>
                    <View style={styles.productoCardLeft}>
                      <Image src={sourceImage} style={styles.productoImagen} />
                    </View>
                    <View style={styles.productoCardRight}>
                      <Text style={styles.detalleCodigo}>Código: {product.code}</Text>
                      <View style={styles.detalleContenido}>
                        {
                          //QUITAR SU LIMITADOR A FUTURO
                        }
                        {product.description && typeof product.description === 'object' ? (
                          Object.entries(product.description).map(([k, v], j) => j <= 4 && (
                            <Text key={j} style={styles.productoInfo}>
                              {k}: {v}
                            </Text>
                          ))
                        ) : (
                          <Text style={styles.productoInfo}>Sin descripción.</Text>
                        )}
                      </View>
                      <View style={styles.PrecioContent}>
                        <Text style={styles.PrecioTitle}>
                          {wholesale ? 'Precio Mayorista:' : 'Precio:'}
                        </Text>
                        <Text style={styles.productoPrecio}>
                          {wholesale
                            ? convertPrice(product.wholesale ?? '0.00')
                            : convertPrice(product.price ?? '0.00')}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              );
            })}
          </View>

          {/* Pie */}
          <View style={styles.footer}>
            {/* Teléfono (sin link) */}
            <View style={styles.contentDatosFooter}>
              <Image src={whatsapt} style={styles.iconFooter} />
              <Link src={phone ? ('https://wa.me/591' + phone) : "#"} style={styles.textFooter}>{phone || "—"}</Link>
            </View>

            {/* Ubicación ––– ahora CON ENLACE */}
            <View style={styles.contentDatosFooter}>
              <Image src={ubicacion} style={styles.iconFooter} />

              {/* usa Link para que sea clic-to-maps; si no llega locationUrl pone # */}
              <Link
                src={locationUrl || "#"}
                style={styles.textFooter}
              >
                {branchName || "—"}
              </Link>
            </View>

            {/* Web (texto estático) */}
            <View style={styles.contentDatosFooter}>
              <Image src={mundo} style={styles.iconFooter} />
              <Link src={link_share ?? "https://hosming.com"} style={styles.textFooter}>Visitanos!</Link>
            </View>
          </View>



        </Page>
      ))}
    </Document>
  );
};

export default ProductosPdf;
